// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__e9E8o","iconWithCounter":"styles_iconWithCounter__Sha53","counterForLabel":"styles_counterForLabel__tT0GY","counterForIcon":"styles_counterForIcon__W5Lu5"};